import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import SEO from "@/components/app/SEO";

const plans = [
  {
    name: "Offre sur mesure",
    price: "50 %",
    priceDetail: "de la cotisation annuelle du contrat",
    tagline: "Devis personnalisé",
    features: ["Fiches vérifiées", "Générateur de courrier", "Téléchargement PDF", "Support dédié"],
    cta: "Demander mon devis",
    key: "download",
    highlight: false,
  },
  {
    name: "Envoi assisté",
    price: "9,90 € TTC",
    priceDetail: "par courrier",
    tagline: "Le plus populaire",
    features: ["Génération et vérification du courrier", "Envoi en recommandé A/R", "Suivi postal détaillé", "Preuve de dépôt & AR", "Coffre-fort numérique"],
    cta: "Envoyer un recommandé",
    key: "assisted",
    highlight: true,
  },
  {
    name: "Accompagnement complet",
    price: "14,90 € TTC",
    priceDetail: "par courrier",
    tagline: "Traitement prioritaire",
    features: ["Tout de l'offre Envoi assisté", "Vérification humaine", "Traitement prioritaire", "Relance automatique", "Assistance dédiée"],
    cta: "Choisir l'accompagnement",
    key: "premium",
    highlight: false,
  },
];

export default function PricingPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
      <SEO
        title="Tarifs"
        description="Tarifs Résiliation Express : Offre sur mesure (50 % de la cotisation annuelle du contrat), Envoi assisté à 9,90 € TTC, Accompagnement complet à 14,90 € TTC. Paiement PayPal, sans engagement."
        canonical="/tarifs"
      />
      <div className="text-center mb-14">
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-3">Tarifs</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">Un tarif clair. Aucun engagement.</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Payez uniquement lorsque vous envoyez un courrier. Aucun abonnement caché.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {plans.map((p) => (
          <div
            key={p.key}
            className={`rounded-xl p-8 border ${p.highlight ? "border-primary shadow-lg scale-[1.02] bg-card" : "border-border bg-card"}`}
            data-testid={`plan-${p.key}`}
          >
            {p.highlight && <div className="inline-block px-3 py-1 rounded-full bg-gradient-brand text-white text-xs font-semibold mb-4">{p.tagline}</div>}
            <div className="text-sm text-muted-foreground mb-1">{p.name}</div>
            <div className="flex items-baseline gap-1 mb-1">
              <span className="text-4xl font-bold tracking-tight">{p.price}</span>
              {p.priceDetail && <span className="text-sm text-muted-foreground">{p.priceDetail}</span>}
            </div>
            {!p.highlight && <div className="text-sm text-muted-foreground mb-6">{p.tagline}</div>}
            <ul className="space-y-3 mb-8 mt-6">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm">
                  <Check className="h-4 w-4 text-green-600 shrink-0 mt-0.5" />
                  {f}
                </li>
              ))}
            </ul>
            <Button asChild className={`w-full ${p.highlight ? "bg-gradient-brand text-white border-0 hover:opacity-90" : ""}`} variant={p.highlight ? "default" : "outline"} data-testid={`plan-cta-${p.key}`}>
              <Link to="/resilier">{p.cta}</Link>
            </Button>
          </div>
        ))}
      </div>

      <div className="mt-16 max-w-3xl mx-auto text-center text-sm text-muted-foreground">
        <p>Paiements traités exclusivement par <strong>PayPal</strong>. Compte PayPal, carte bancaire (Visa, Mastercard), Paiement en 4X (sous réserve d'éligibilité PayPal — Résiliation Express ne gère pas les échéances).</p>
      </div>
    </div>
  );
}
